import { useQuery } from '@tanstack/react-query'
import { useMemo } from 'react'
import { setGraphClientAuthToken } from '../../../services/graph-client'
import { profileService } from '../../../services/profile'

export const MY_PROFILE_MINI_QUERY_KEY = ['getMyProfileMini']

export const useGetMyProfileMini = () => {
  const { data, isLoading } = useQuery({
    queryKey: MY_PROFILE_MINI_QUERY_KEY,
    staleTime: Infinity,
    queryFn: () => {
      const token = typeof window !== 'undefined'
        ? (new URLSearchParams(window.location.search).get('token') ?? window.localStorage.getItem('@token'))
        : null
      setGraphClientAuthToken(token)
      return profileService.getMini()
    },
  })

  const user = useMemo(() => data?.data, [data])

  return { user, isLoading }
}
